// extracted by mini-css-extract-plugin
module.exports = {"prompt":"prompt_prompt__3ViNN","warn":"prompt_warn__2yT9Z","importText":"prompt_importText__9P4LO"};